<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">New Users</div>
                <button type="button" id='exportUsers' class="btn btn-primary ml-1 pull-right"
                        v-on:click="exportUsersData($event)">
                    Export
                </button>
                <button type="button" class="btn btn-primary ml-1 pull-right" data-toggle="modal" data-target="#newUserImportModal">
                    Import
                </button>
                <button type="submit" v-on:click.prevent="addBenefit" class="btn btn-primary waves-effect pull-right">Add</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="notregisterUserList"
                        mode="remote"
                        title="New User List"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"
                        :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"

                        :search-options="{
                        enabled: false,
                        }">

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <router-link title='Edit User' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'UpdateNotRegisteredUser',params:{id:props.row.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                    <a title='Delete User' id="delete" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="deleteSingleUser(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>

                                   <template v-if="loginUserId != props.row.id">
                                        <template v-if="props.row.is_active">
                                            <a v-on:click="changeActiveInactiveStatus(props.row.id, 'Deactive')" class="btn edit-btn-vvg waves-effect" title="Make Deactive">
                                                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a v-on:click="changeActiveInactiveStatus(props.row.id, 'Active')" class="btn edit-btn-vvg waves-effect" title="Make Active">
                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                            </a>
                                        </template>
                                    </template>

                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>

                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button data-toggle="modal" id="changeRoleModel" title='Change role' class="btn btn-primary" data-target="#changeRole">Change Role</button>
                            <!--<button data-toggle="modal" id="changeLocationModel" title='Change location' class="btn btn-primary" data-target="#changeLocation" >Change Location</button>-->
                            <button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="changeSelectedUserDetails('deleteMultipleUsres')">Delete Users ({{selectedRows}})</button>

                            <button v-on:click="changeActiveInactiveStatus(0, 'Active')" class="btn btn-success" title="Make Active">Active ({{selectedRows}})</button>
                            <button v-on:click="changeActiveInactiveStatus(0, 'Deactive')" class="btn btn-danger" title="Make Deactive">Deactive ({{selectedRows}})</button>
                        </div>

                    </vue-good-table>

                    <div class="modal fade" id="changeRole" role="dialog">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title" id="defaultModalLabel">Change Designation</h4>
                                    <!--<button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="roleData">Designation</label>
                                            <!--<select class="form-control show-tick" id="roleData" v-model="roleId">-->
                                            <!--<template v-for="(roleData , index) in roleArr">-->
                                            <!--<option :value="roleData.value">{{roleData.text}}</option>-->
                                            <!--</template>-->
                                            <!--</select>-->
                                            <v-select v-model="roleId"
                                                      @change="changedValue"
                                                      @input="changedValueRole()"
                                                      name="roleId"
                                                      id="roleId"
                                                      label="text"
                                                      :filterable="false"
                                                      :options="roleArr"
                                                      @search="onSearchRole"
                                                      placeholder="Select Role">
                                                <template slot="no-options">
                                                    Search Role...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                        <button data-dismiss="modal" type="submit" v-on:click.prevent="changeSelectedUserDetails('change_role')" class="btn btn-primary">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="changeLocation" role="dialog">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title" id="defaultModalLabel">Change Location</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="locationId">State</label>
                                            <v-select v-model="locationId"
                                                      @change="changedValue"
                                                      name="locationId"
                                                      id="locationId"
                                                      label="text"
                                                      :filterable="false"
                                                      :options="locationArr"
                                                      @search="onSearchLocation"
                                                      placeholder="Select State">
                                                <template slot="no-options">
                                                    Search State...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                        <button type="submit" data-dismiss="modal" v-on:click.prevent="changeSelectedUserDetails('change_location')" class="btn btn-primary">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <div class="modal fade" id="newUserImportModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="defaultModalLabel">Import New Users Excel</h4>
                    </div>
                    <form class="form-inline" id="importTasksform" enctype="multipart/form-data">
                        <div class="modal-body">
                            Select Excel File to Import New Users
                            <label class="myLabel btn btn-primary">
                                <input style="display: none;" type="file" name="excl_file" accept=".xlsx,.xls" id="upload" ref="filesUserData" v-on:change="handleFilesUploadCall()"/>
                                <span>Select File ...</span>
                            </label>
                            <div class="form-group">
                                <label id="errorMsg" class="error"></label><br>
                            </div>
                            <div class="clearfix">
                                <a id ="demourl" href="demoUrl" target="_blank" class="btn btn-primary">
                                    Download Demo
                                </a>
                            </div>
                            <div class="clearfix"></div>
                            <!--Error Alert-->
                            <div class="row clearfix" >
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="mt-10 alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="backErrorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row mt-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <button type="button" v-on:click="importUsersData($event);" class="btn btn-primary mr-2">Import</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import VueSweetalert2 from 'vue-sweetalert2';

    Vue.use(VueSweetalert2);

    var self;
    export default {
        name: 'ListBenefits',
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                loginUserId: 0,

                exportUsers: false,
                filesUser: false,
                filesUserData: [],
                firstLoad: 0,
                roleId: 0,
                roleArr: [],
                locationId: 0,
                locationArr: [],
                columns: [
                    {
                        label: 'First Name',
                        field: 'first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "First Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Last Name',
                        field: 'last_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Last Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, {
                        label: 'DayForce Id',
                        field: 'dayforce_id',
                        filterable: true,
                        filterOptions: {
//                            placeholder: "MM/DD/YYYY",
                            enabled: true, // enable filter for this column
                            placeholder: "DayForce Id", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                     {
                        label: 'Email',
                        field: 'email',
                        filterable: true,
                        filterOptions: {
//                            placeholder: "MM/DD/YYYY",
                            enabled: true, // enable filter for this column
                            placeholder: "Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'State',
                        field: 'location_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "State", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'site_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Department',
                        field: 'department_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Designation',
                        field: 'role_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Designation", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Status", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['Active', 'Deactive'], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserId = userJson['id'];
            }
            var initial = process.env.ROOT_API;
            initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/import/ImportEmployeesDemo.xlsx');
//            self = this;
            self.loadNotRegisteredUser();
//            self.loadRole();
            self.loadRoleAdd();
            self.loadLocationsAdd();
            $("#alertError").hide();
        },
        methods: {
            changeActiveInactiveStatus: function (id, state) {
                var use = [];
                if(id == 0) {
                    var data = this.$refs['notregisterUserList'].selectedRows;
                    for (var i = 0; i < data.length; i++) {
                        use.push(this.$refs['notregisterUserList'].selectedRows[i].id)
                    }

                }
                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to ' + state + ' this User!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var fields = {
                            id: (id != 0) ? id : use,
                            state: state,
                            flag: (id != 0) ? 'oneByOne' : 'all'
                        };
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        };
                        self.showLoader();
                        HTTP.post("activeordeative", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.loadNotRegisteredUser();
                                }
                                self.hideLoader();
                            })
                            .catch(function (error) {
                                self.hideLoader();
                                self.catchHandler(error, function () {});
                            });
                    }
                });
            },
            changedValue: function (value) {
                //console.log(value);
            },

            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            addBenefit() {
                self.$router.push('/backend/addnotregistereduser');
            },

            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadNotRegisteredUser();
            },
            //
            onPerPageChange(params) {
                console.log("onPerPageChange = " + JSON.stringify(params));
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadNotRegisteredUser();
                }
            },
            selectionChanged() {
                var self = this;
                self.selectedRows = (self.$refs['notregisterUserList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },

            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('first_name');
                    field: ('last_name');
                    field: ('dayforce_id');
                    field: ('location_name');
                    field: ('role_name');
                    field: ('status');
                    field: ('updated_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.first_name || filters.last_name || filters.dayforce_id || filters.location_name || filters.role_name || filters.status || filters.updated_by) {
                    self.loadNotRegisteredUser();
                }

            },

            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadNotRegisteredUser();
            },

            loadRoleAdd() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            /*self.roleArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.roleArr.push(response.data.content[i]);
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            loadRole(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    search: search
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            /*self.roleArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.roleArr.push(response.data.content[i]);
                                }
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            changedValueRole: function () {
                self.designationError = "";
            },
            onSearchRole(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadRole(loading, search, this);
                }
            },

            deleteSingleUser: function (id) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var fields = {
                    deleteId: id,
                };

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.post("changeselectedrole", fields, config)
                                .then(function (response) {
                                    self.loadNotRegisteredUser();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        this.$swal('Deleted', 'You successfully deleted user(s)', 'success');
                    } else {
                        self.$swal('Cancelled', 'Your file is still intact', 'info');
                    }
                })


            },

            changeSelectedUserDetails: function (action) {
                var selectedUser = self.$refs['notregisterUserList'].selectedRows;
                var userArr = [];
                for (var i = 0; i < selectedUser.length; i++) {
                    userArr.push(this.$refs['notregisterUserList'].selectedRows[i].id);
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                switch (action) {
                    case 'change_role' :
                        var fields = {
                            userArr: userArr,
                            roleId: self.roleId.value,

                        };
                        break;

                    case 'change_location' :
                        var fields = {
                            userArr: userArr,
                            locationId: self.locationId,

                        };
                        break;

                    case 'deleteMultipleUsres' :
                        var fields = {
                            deleteIds: userArr,
                        };
                        break;

                }
                if (action == 'deleteMultipleUsres') {
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You can\'t revert your action',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes Delete it!',
                        cancelButtonText: 'No, Keep it!',
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                            self.showLoader();
                            HTTP.post("changeselectedrole", fields, config)
                                    .then(function (response) {
                                        self.roleId = self.locationId = 0;
                                        self.loadNotRegisteredUser();
                                        self.hideLoader();
                                    })
                                    .catch(function (err) {
                                        if (err.response.status == 0) {
                                            self.error = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                                //EventBus.$emit("logged-in", true, "", "");
                                            }
                                        }
                                        self.hideLoader();
                                    });
                            this.$swal('Deleted', 'You successfully deleted user(s)', 'success')
                        } else {
                            this.$swal('Cancelled', 'Your file is still intact', 'info')
                        }
                    })
                } else if (action == 'change_role' || action == 'change_location') {
                    console.log("in else");
                    self.showLoader();
                    HTTP.post("changeselectedrole", fields, config)
                            .then(function (response) {
                                self.roleId = self.locationId = 0;
                                self.loadNotRegisteredUser();
                                if (action == 'change_role') {
                                    self.$swal({
                                        type: 'success',
                                        text: 'Role Changed Successfully',
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                }
                                if (action == 'change_location') {
                                    self.$swal({
                                        type: 'success',
                                        text: 'Location Changed Successfully',
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                                self.hideLoader();
                            });
                }

            },

//            loadRole() {
//                var config = {
//                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
//                };
//                HTTP.post("getroles", '', config)
//                    .then(function (response) {
//                        self.roleArr = response.data.content;
//                    })
//                    .catch(function (err) {
//                        if (err.response.status == 0) {
//                            self.error = "Remote server can not be reachable";
//                        } else {
//                            //redirect to login page if user not authenticated
//                            if (err.response.status == 401) {
//                                //clear previous data
//                                localStorage.removeItem("user_obj");
//                                localStorage.removeItem("api_token");
//                                localStorage.removeItem("profile_image");
//                                self.$router.push("/login");
//                                //EventBus.$emit("logged-in", true, "", "");
//                            }
//                        }
//                    });
//            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            /*self.locationArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            loadNotRegisteredUser: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }

                if(self.serverParams.columnFilters.status == 'Active') {
                    self.serverParams.columnFilters.status = 1;
                } else if(self.serverParams.columnFilters.status == 'Deactive') {
                    self.serverParams.columnFilters.status = 0;
                }

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    export_users: self.exportUsers
                };
                self.showLoader();
                HTTP.post('listnotregistereduser', fields, config)
                        .then(function (response) {
                            $('#exportUsers').text('Export');
                            $('#exportUsers').prop("disabled", false);
                            if (response.data.message == "success export") {
                                location.href = response.data.content.web;
                            } else if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }
                            self.exportUsers = false;

                            if(self.serverParams.columnFilters.status == 1) {
                                self.serverParams.columnFilters.status = 'Active';
                            } else if(self.serverParams.columnFilters.status.length != 0 && self.serverParams.columnFilters.status == 0) {
                                self.serverParams.columnFilters.status = 'Deactive';
                            }

                            self.hideLoader();
                        })
                        .catch(function (err) {
                            $('#exportUsers').text('Export');
                            $('#exportUsers').prop("disabled", false);
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.exportUsers = false;
                            self.hideLoader();
                        })
            },
            exportUsersData: function () {
                self.showLoader();
                self.exportUsers = true;
                if (self.exportUsers == true) {
                    $('#exportUsers').text('Exporting...');
                    $('#exportUsers').prop("disabled", true);
                    self.loadNotRegisteredUser();
                }
                self.hideLoader();
            },
            hideModelCall() {
                $('#newUserImportModal').modal('hide');
                return false;
            },
            importUsersData(e) {
                $(e.target).text('Importing...');
                $(e.target).prop("disabled", true);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = new FormData();
                for (var i = 0; i < self.filesUserData.length; i++) {
                    let file = self.filesUserData[0];
                    //console.log(file);
                    fields.append('excl_file', file);
                }
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You want to import users?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes import it!',
                    cancelButtonText: 'No, Don\'t import it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.post('importusers', fields, config)
                                .then(function (response) {
                                    $(e.target).text('Import');
                                    $(e.target).prop("disabled", false);
                                    if (response.data.code == '200') {
                                        self.filesUserData = [];
                                        $('#upload').val('');
                                        $('#newUserImportModal').modal('hide');
                                        self.$swal({
                                            type: 'success',
                                            text: 'Users Imported Successfully',
                                            showConfirmButton: false,
                                            timer: 5000,
                                        });
                                        self.loadNotRegisteredUser();
                                    } else {
                                        $("#alertError").show();
                                        console.log(response.data.content);
                                        $("#backErrorMsg").html(response.data.content);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    $(e.target).text('Import');
                                    $(e.target).prop("disabled", false);
                                    //$('#queueEmail').modal('hide');
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        } else {
                                            $("#alertError").show();
                                            $("#backErrorMsg").html(err.response.data.content);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                    self.hideLoader();
                                });
                    } else {
                        self.$swal('Cancelled', 'Your have canceled import users', 'info')
                        $(e.target).text('Import');
                        $(e.target).prop("disabled", false);
                        self.filesUserData = [];
                        $('#upload').val('');
                        $('#newUserImportModal').modal('hide');
                    }
                });
            },
            handleFilesUploadCall: function () {
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesUserData.files;

                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesUserData = [uploadedFiles[i]];
                }
                /*this.getImagePreviews();*/
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/notregisteredusers/ListNotRegisteredUser.vue